"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantAttachmentChip = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@assistant-ui/react");
const _ui_1 = require("@ui");
const util_1 = require("@app/util");
require("./assistant-attachment-chip.scss");
/**
 * One attachment waiting in the composer, on its own row above the input: a paperclip, the file
 * name, the file size, and a control that takes it back out again.
 *
 * Presentation only. Adding, the 10 MB cap, the accepted types and drag-and-drop all belong to
 * `fileAttachmentAdapter` and the library's dropzone, and removing is the library's own
 * `AttachmentPrimitive.Remove` — which calls the adapter's `remove` and drops the attachment
 * from the composer, so what the manager sees here is exactly what would be sent.
 *
 * `file` is only guaranteed on a *pending* attachment (`BaseAttachment.file` is optional), and
 * this chip only ever renders pending ones — a sent attachment is `SentAttachment` in
 * `manager-assistant-chat.tsx`. The size is still guarded rather than asserted: the type says it
 * can be absent and a chip with no size reads fine.
 */
const AssistantAttachmentChip = () => {
    const size = (0, react_2.useAttachment)((attachment) => attachment.file?.size);
    return (react_1.default.createElement(react_2.AttachmentPrimitive.Root, { className: 'ds-ma-attachment', "data-testid": 'ai-attachment' },
        react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.attachment, size: _ui_1.Icon.SIZES.SMALL, color: _ui_1.Icon.COLORS.INHERIT }),
        react_1.default.createElement("span", { className: 'ds-ma-attachment-name' },
            react_1.default.createElement(react_2.AttachmentPrimitive.Name, null)),
        (0, util_1.isValue)(size) && (react_1.default.createElement("span", { className: 'ds-ma-attachment-size' }, (0, util_1.bytesToSize)(size, ' '))),
        react_1.default.createElement(react_2.AttachmentPrimitive.Remove, { className: 'ds-ma-attachment-remove', title: (0, util_1.t)('REMOVE') ?? undefined, "aria-label": (0, util_1.t)('REMOVE') ?? undefined, "data-testid": 'ai-attachment-remove' },
            react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.close1, size: _ui_1.Icon.SIZES.SMALL, color: _ui_1.Icon.COLORS.INHERIT }))));
};
exports.AssistantAttachmentChip = AssistantAttachmentChip;
exports.default = AssistantAttachmentChip;
